import React from "react";
import { Link } from "react-router-dom";
import { FaChalkboardTeacher, FaComments, FaUserCircle } from "react-icons/fa";

const FooterMenu = ({ selectMainTap }) => {
    return (
        <div className="footer-template hc-mobile-footer">
            <ul className="list-group list-group-horizontal">
                <Link to="/list_friend_hiclass">
                    <li className={"footer-menu" + (selectMainTap === "LIST_FRIEND" ? " active" : "")} title={"\uB0B4 \uC815\uBCF4"}>
                        <FaUserCircle className="footer-menu-svg" aria-hidden="true" />
                        <span className="footer-menu-label">{"\uB0B4 \uC815\uBCF4"}</span>
                    </li>
                </Link>
                <Link to="/list_live_hiclass">
                    <li className={"footer-menu" + (selectMainTap === "LIST_LIVE" ? " active" : "")} title={"\uD074\uB798\uC2A4"}>
                        <FaChalkboardTeacher className="footer-menu-svg" aria-hidden="true" />
                        <span className="footer-menu-label">{"\uD074\uB798\uC2A4"}</span>
                    </li>
                </Link>
                <Link to="/chatting_hiclass">
                    <li className={"footer-menu" + (selectMainTap === "CHATTING" ? " active" : "")} title={"\uD1A1"}>
                        <FaComments className="footer-menu-svg" aria-hidden="true" />
                        <span className="footer-menu-label">{"\uD1A1"}</span>
                    </li>
                </Link>
            </ul>
        </div>
    );
}

export default FooterMenu;
